export default {
  methods: {
    errorMail(compTitle, compId) {
      // const route = useRoute()
      let insightInfoGlobal = this.$sessionData.get('insightInfoGlobal')
      let asgid = this.$sessionData.get('asgID404')
      let wgtName = compTitle
      let startdate = insightInfoGlobal.startdate;
      let enddate = insightInfoGlobal.enddate;
      let Analyzefield = insightInfoGlobal.analysison[0].dbname;
      let filtervals = "";
      let analyzeflds;
      let pushdispvals = {};
      let getdropsdata = insightInfoGlobal.dropdata
      let portlevels = insightInfoGlobal.prior_op
      for (let i = 0; i < insightInfoGlobal.prior_op.length; i++) {
        pushdispvals = getdropsdata.find(x => x.dbname === insightInfoGlobal.prior_op[i].filter_key)
        portlevels[i].filterDisp = pushdispvals.name
        analyzeflds = pushdispvals.name
      }
      filtervals = JSON.stringify(analyzeflds);
      let filterlvls = "filterlvlNone";
      let elemt = document.getElementById(compId)
      let screen = {
        width: elemt.clientWidth,
        height: elemt.clientHeight
      }
      // let sendermail = JSON.parse(sessionStorage.mailto)
      let sendermail = this.$sessionData.get('uinofo_sess').mailto;
      let subject = "Opsight Azure GA Support : Reporting Widget Error Issue";
      let yourMessage = "Hi Support team," +
        "\n\nBelow are the details that are captured for this widget error:\n";
      yourMessage += "Assessment ID : " + asgid + "\n";
      yourMessage += "Widget Name: " + wgtName + "\n";
      yourMessage += "Date Period : " + startdate + '-' + enddate + "\n";
      if (Analyzefield != undefined) {
        yourMessage += "Analysis Based on : " + Analyzefield + "\n";
      }
      if (filtervals) {
        yourMessage += "Filter Selected: " + filtervals + "\n";
      } else {
        yourMessage += "Filter Selected: " + "No Filter Values selected" + "\n";
      }
      if (filterlvls != "filterlvlNone") {
        yourMessage += "Filter Levels Selected: " + filterlvls + "\n";
      }
      yourMessage += "\nResolution: " + screen.width + "x" + screen.height + "\n";
      if (screen.width != window.outerWidth || screen.height != window.outerHeight)
        yourMessage += "Browser Resolution: " + window.outerWidth + "x" + window.outerHeight + "\n";
      yourMessage += "Zoom Level: " + Math.round(window.devicePixelRatio * 100) + "%\n";
      yourMessage += "User Agent: " + navigator.userAgent + "\n";
      document.location.href = sendermail +
        encodeURIComponent(subject) +
        "&body=" + encodeURIComponent(yourMessage);
    }
  }
}